// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AlnW","top":"styles_top__1AjfW"};